class EventEmitter {
    private _messages:any = {};
  
    constructor() {}
  
    // 注册信息接口
    public regist = (type: string, fn: Function) => {
      if (typeof this._messages[type] === 'undefined') {
        this._messages[type] = [fn];
      } else {
        this._messages[type].push(fn);
      }
    };
    // 发布信息接口
    public fire = (type: string, args: unknown | unknown[] = []) => {
      if (!this._messages[type]) return;
      const len = this._messages[type].length;
      for (let i = 0; i < len; i++) {
        this._messages[type][i](args);
      }
    };
    // 移除信息接口
    public remove = (type: string, fn?: Function) => {
      if (this._messages[type] instanceof Array) {
        if (!fn) {
          this._messages[type] = [];
          return;
        }
        let i = this._messages[type].length - 1;
        for (; i >= 0; i--) {
          this._messages[type][i] === fn && this._messages[type].splice(i, 1);
        }
      }
    };
  }
  
  export const eventEmitter = new EventEmitter();


  export const EventType = {
    homeScrollToModules:'homeScrollToModules'
  }